import React, { useEffect } from 'react';
import './Modal.css';

const AboutContent = ({ onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>About Free Finder</h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          <div className="simple-modal">
            <div className="simple-section">
              <h3 className="section-title">What is Free Finder?</h3>
              <p>
                Free Finder is a powerful tool designed to discover $0 priced products across 
                any Shopify store. Whether you're looking for promotional items, testing 
                products, or free samples, Free Finder helps you locate them instantly. No 
                registration or API keys required - just paste a store URL and start searching.
              </p>
            </div>

            <div className="simple-section">
              <h3 className="section-title">Key Features</h3>
              <div className="features-grid">
                <div className="feature-item">
                  <i className="fas fa-store"></i>
                  <span>Universal Shopify store compatibility</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-file-upload"></i>
                  <span>Bulk processing with URL lists</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-sync"></i>
                  <span>Real-time product scanning</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-file-export"></i>
                  <span>Export & import functionality</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-pause"></i>
                  <span>Pause & resume batch processing</span>
                </div>
                <div className="feature-item">
                  <i className="fas fa-moon"></i>
                  <span>Light & dark theme support</span>
                </div>
              </div>
            </div>

            <div className="simple-section">
              <h3 className="section-title">Important Information</h3>
              <div className="info-box">
                <p>
                  While products may be listed at $0, shipping costs and other fees might 
                  still apply. Always check the final checkout price before completing any purchase.
                </p>
              </div>
              <div className="info-box">
                <p>
                  Free Finder respects store rate limits and implements ethical scanning practices. 
                  The tool is designed for legitimate product discovery, not server stress testing.
                </p>
              </div>
              <div className="info-box twitter-promo">
                <i className="fab fa-twitter"></i>
                <p>
                  Follow <a href="https://twitter.com/freefinderio" target="_blank" rel="noopener noreferrer">@freefinderio</a> on 
                  Twitter for the latest updates, features, and announcements about Free Finder.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent; 